import { Controller } from '@hotwired/stimulus'
import { enter, leave, toggle } from 'el-transition'

export default class extends Controller {
  static targets = ['item']
  static classes = ['hidden']

  connect () {
    this.class = this.hasHiddenClass ? this.hiddenClass : 'hidden'
  }

  toggle () {
    toggle(this.itemTarget)
  }

  show () {
    enter(this.itemTarget)
  }

  hide (event) {
    if (this.clickedOutside(event) || this.escapePressed(event)) {
      leave(this.itemTarget)
    }
  }

  clickedOutside (event) {
    return !this.element.contains(event.target) && !this.itemTarget.classList.contains('hidden')
  }

  escapePressed (event) {
    return event instanceof window.KeyboardEvent && event.key === 'Escape'
  }
}
